// @flow strict
import * as React from 'react';
import type { GroupToursBySection } from '../../records/Tour.js';
import type { Poi } from '../../records/Poi.js';
import type { PoiToursSectionContent } from '../../records/PoiToursSectionContent.js';
import type { Language } from '../intl/context.js';
import { createEmptyPoisByLocale } from '../localeDefaults.js';

export type PoiToursSectionContextType = {
  poi: { [Language]: Poi },
  tours: GroupToursBySection,
  sectionContent: ?PoiToursSectionContent,
  popularAttractions: Poi[],
};

const PoiToursSectionContext = React.createContext < PoiToursSectionContextType > ({
  poi: createEmptyPoisByLocale(),
  tours: {},
  sectionContent: null,
  popularAttractions: [],
});

export default PoiToursSectionContext;
